import { render, staticRenderFns } from "./navMenu.vue?vue&type=template&id=3667d836&scoped=true&"
import script from "./navMenu.vue?vue&type=script&lang=js&"
export * from "./navMenu.vue?vue&type=script&lang=js&"
import style0 from "./navMenu.vue?vue&type=style&index=0&id=3667d836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667d836",
  null
  
)

export default component.exports